// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1qkwB","validationTips":"StatementDescriptor_validationTips__382wz"};